export default function ShareMenu(url) {
  return [
    {
      id: 0,
      title: "Twitter",
      icon: "mdi:twitter",
      url: `https://twitter.com/intent/tweet?url=${url}`,
    },
    {
      id: 1,
      title: "LinkedIn",
      icon: "mdi:linkedin",
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
    },
    {
      id: 2,
      title: "Facebook",
      icon: "mdi:facebook",
      url: `https://www.facebook.com/sharer.php?u=${url}`,
    },
    {
      id: 3,
      title: "Get Link",
      icon: "ph:copy",
      url: () => navigator.clipboard.writeText(url),
    },
  ];
}
